import React from "react";

const Faq = () => {
  return (
    <div className="App">
      <div class="py-5">
        <div class="shadow p-5 w-75 mx-auto my-4 rounded">
          <h2 className="text-xl"> What is the tutorial's duration? </h2>
          <p>approximately 4-5 month</p>
        </div>
        <div class="shadow p-5 w-75 mx-auto my-4 rounded">
          <h2 className="text-xl">Support time per day</h2>
          <ul>
            <li>At morning 11 am - 1.00 pm</li>
            <li>At evening (4-6) pm</li>
            <li>At night (9-11) pm</li>
          </ul>
        </div>
        <div class="shadow p-5 w-75 mx-auto my-4 rounded">
          <h2 className="text-xl"> Assignment's</h2>
          <p> Every student must do 7 assignment</p>
        </div>
        <div class="shadow p-5 w-75 mx-auto my-4 rounded">
          <h2 className="text-xl"> Our team for support</h2>
          <p>We have team of 200 members for support</p>
        </div>
      </div>
      s
    </div>
  );
};

export default Faq;
